const loadDesigns = () => {
    try {
        // This must remain a direct call so Create React App/webpack creates a
        // context containing every matching image in the folder.
        const images = require.context('../assets/back-cards', false, /\.(png|jpe?g|webp|gif)$/i);
        return images.keys().sort((left, right) => left.localeCompare(right, undefined, { numeric: true }))
            .map(key => ({ id: key.replace(/^\.\//, ''), image: images(key)?.default || images(key) }));
    } catch {
        // Jest and other non-webpack tools do not implement require.context.
        return [];
    }
};

export const CARD_BACK_DESIGNS = loadDesigns();
// Change only this filename when a different card back should be selected for
// newly created rooms. If the file is removed, the first available design is
// used so the deck never renders without a back image.
export const DEFAULT_CARD_BACK_FILE_NAME = 'back-card1.png';
export const DEFAULT_CARD_BACK_DESIGN = CARD_BACK_DESIGNS.some(design => design.id === DEFAULT_CARD_BACK_FILE_NAME)
    ? DEFAULT_CARD_BACK_FILE_NAME
    : CARD_BACK_DESIGNS[0]?.id || '';

const normalizeDesign = designId => CARD_BACK_DESIGNS.some(design => design.id === designId)
    ? designId
    : DEFAULT_CARD_BACK_DESIGN;

export const getCardBackImage = designId => CARD_BACK_DESIGNS.find(design => design.id === normalizeDesign(designId))?.image
    || CARD_BACK_DESIGNS[0]?.image;

const decodedImages = new Map();

// Resolve only after the browser has downloaded and decoded the selected back.
// Keeping the promise cached also prevents every room snapshot from decoding a
// multi-megabyte image again.
export const preloadCardBackImage = designId => {
    const source = getCardBackImage(designId);
    if (!source || typeof Image === 'undefined') return Promise.resolve(source);
    if (decodedImages.has(source)) return decodedImages.get(source);

    const ready = new Promise(resolve => {
        const image = new Image();
        const finish = () => resolve(source);
        image.onload = () => {
            if (typeof image.decode === 'function') image.decode().catch(() => {}).finally(finish);
            else finish();
        };
        image.onerror = finish;
        image.src = source;
        if (image.complete) image.onload();
    });
    decodedImages.set(source, ready);
    return ready;
};

